<template>
  <div id="text-to-date" ref="text-to-date-wrapper">
    <label v-if="label" v-html="label"></label>
    <div
      class="text-wrapper"
      v-if="showText"
      :style="`height: ${this.height}`"
      @click="switchElement"
    >
      <div>
        {{ textValue }}
      </div>
    </div>
    <date-picker
      v-if="!showText"
      @popoverDidHide="switchElement"
      v-model="inputText"
      :inputFormat="inputFormat"
      :titleFormat="titleFormat"
    />
  </div>
</template>

<script>
export default {
  name: "TextToDate",
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: ""
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    inputFormat: {
      type: String,
      required: false,
      default: "YYYY. MMMM DD"
    },
    titleFormat: {
      type: String,
      required: false,
      default: "YYYY. MMMM DD"
    },
    width: {
      type: String,
      required: false,
      default: "100%"
    },
    height: {
      type: String,
      required: false,
      default: "30px"
    },
    textValue: {
      type: String,
      required: false,
      default: ""
    }
  },
  components: {},
  data() {
    return {
      inputText: this.value,
      showText: true
    };
  },
  mounted() {
    this.$refs["text-to-date-wrapper"].style.width = this.width;
  },
  computed: {},
  watch: {
    showText() {
      if (this.showText) {
        this.$emit("input", this.inputText);
      }
    }
  },
  methods: {
    switchElement() {
      this.showText = !this.showText;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#text-to-date {
  position: relative;
  label {
    padding-left: 5px;
    font-size: 13px;
    margin: 0;
  }
  .text-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: 6px;
    padding: 0 12px 0 12px;
    outline: none;
    transition: all 1s;
    border: none;
    padding: 0 12px 0 12px;
    cursor: pointer;
  }

  input {
    min-width: 250px;
    height: 100%;
    width: 100%;
    border-radius: 6px;
    background: #f3f3f3;
    padding: 0 12px 0 12px;
    outline: none;
    transition: all 1s;
    border: none;
    // box-shadow: $input-shadow;
  }
}
</style>
